import { render, staticRenderFns } from "./SwipeUp.vue?vue&type=template&id=1d88b0f4&scoped=true&lang=pug&"
import script from "./SwipeUp.vue?vue&type=script&lang=js&"
export * from "./SwipeUp.vue?vue&type=script&lang=js&"
import style0 from "./SwipeUp.vue?vue&type=style&index=0&id=1d88b0f4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d88b0f4",
  null
  
)

component.options.__file = "SwipeUp.vue"
export default component.exports